import { memo } from "react";
import { useTranslation } from "react-i18next";

const ChatBubble = memo(({ open, onClick }) => {
  const { t } = useTranslation("navigation");
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={t(open ? "chat.schliessen" : "chat.oeffnen")}
      aria-expanded={open}
      className="ci-chat-trigger"
    >
      {open ? (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      ) : (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z" />
        </svg>
      )}
    </button>
  );
});

export default ChatBubble;
